module.exports = __webpack_public_path__ + "static/media/image14.357c1eef.png";